$(document).ready(() => {

  if ($('.rating').length > 0) {
    $('.rating__star').on('click', function() {
      $('.rating__star')
        .removeClass('active');
      $(this)
        .addClass('active');
    });
  }
});
